"use client";

import { useEffect, useState } from "react";
import { userService } from "@/app/services/services";
import type { ApiProduct } from "@/app/types/domain";

export function useDashboardProducts() {
  const [products, setProducts] = useState<ApiProduct[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadProducts() {
      try {
        const productsList = await userService.getProducts();
        if (isMounted) {
          setProducts(Array.isArray(productsList) ? productsList : []);
        }
      } catch (error) {
        console.error("getProducts error:", error);
        if (isMounted) {
          setProducts([]);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    void loadProducts();

    return () => {
      isMounted = false;
    };
  }, []);

  return { products, isLoading };
}
